import 'phaser'
import { assert } from '../lib/assert-sidecar'
import { distanceSquared } from '../lib/distance'
import { l } from '../lib/imports'
import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { frameInfo } from '../main/frameInfo-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { ICargo } from './cargoes'
import { ICargoType } from './cargoesData'
import { entitiesUtils } from './entitiesUtils-sidecar'
import { fullnessIndicators } from '../indicators/fullnessIndicators-sidecar'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { cargoesData } from './cargoesData-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'

export function getAll() {
  return machines.getAllStacks()
}
export function findById(id: number) {
  return entitiesUtils.findById(id, getAll())
}

export function ensureStack(obj: IMachine) {
  assert.t(obj.data.isStack, 'object is not stack!')
}

let frames = [frameInfo.fi32(5, 3, 5)]

export const frame = frames[0]

export function findClosestStackForStorage(
  i: number,
  j: number,
  cargoType: ICargoType,
  ignore: IMachine[] | null,
): IMachine | null {
  let closest: IMachine | null = null
  let closestDistance: number = 9999999

  let objs = getAll()
  for (let idx = 0; idx < objs.length; idx++) {
    let c = objs[idx]

    if (c.holdsType !== cargoType) {
      continue
    }

    // TODO: different stacks with different amounts
    if (c.cargoes.length >= c.data.stackMaxSize) {
      continue
    }

    if (ignore) {
      if (ignore.indexOf(c) !== -1) {
        continue
      }
    }

    let d2 = distanceSquared(i, j, c.i, c.j)
    if (d2 < closestDistance) {
      closest = c
      closestDistance = d2
    }
  }
  if (closest) {
    ensureStack(closest)
  }
  return closest
}

export function findAtSpot(
  i: number,
  j: number,
  filter: (c: IMachine) => boolean,
): IMachine | null {
  let closest: IMachine | null = null
  let objs = getAll()
  l.forEach(objs, (c) => {
    if (c.i === i && c.j === j) {
      if (filter(c)) {
        closest = c
        return false
      }
    }
  })
  if (closest) {
    ensureStack(closest)
  }
  return closest
}

export function kill(obj: IMachine) {
  ensureStack(obj)
  machines.kill(obj)
}

export function update(obj: IMachine) {
  let ctx = scene.getContext()

  if (obj.fullnessIndicator) {
    fullnessIndicators.attach(
      obj.fullnessIndicator,
      obj.image.x + 10,
      obj.image.y + 12,
      obj.cargoes.length / obj.data.stackMaxSize,
    )
  }

  if (obj.cargoes.length === 0) {
    if (obj.imageGhost) {
      obj.imageGhost.visible = true
      let cd = cargoesData.getByType(obj.holdsType)
      spriteMap.setFrame(obj.imageGhost, cd.frame)
    }
    stevieText.setText(obj.text, '')
  } else {
    if (obj.imageGhost) {
      obj.imageGhost.visible = false
    }
    stevieText.setText(obj.text, '' + obj.cargoes.length)
  }
}

export function addToStack(obj: IMachine, cargo: ICargo): boolean {
  ensureStack(obj)
  if (obj.cargoes.length >= obj.data.stackMaxSize) {
    return false
  }
  if (obj.holdsType !== cargo.data.type) {
    console.warn(
      'trying to put wrong type in stack',
      obj.holdsType,
      cargo.data.type,
    )
    return false
  }
  assert.notNil(cargo)
  assert.nil(cargo.inStack)
  assert.notIn(obj.cargoes, cargo)

  cargo.inStack = obj
  layers.getLayers().stackedCargo.add(cargo.image)
  obj.cargoes.push(cargo)

  return true
}
export function removeFromStack(obj: IMachine, cargo: ICargo) {
  ensureStack(obj)
  assert.notNil(cargo)
  assert.eq(cargo.inStack, obj)
  assert.isIn(obj.cargoes, cargo)

  cargo.inStack = null
  layers.getLayers().cargo.add(cargo.image)
  l.remove(obj.cargoes, cargo)

  return true
}
